import {createAction, createAsyncThunk} from '@reduxjs/toolkit';

import {getPlanSubscriptions} from '@explorer/api/auth';

export const fetchSubscriptions = createAsyncThunk(
  'subscriptions/fetch',
  () => {
    return getPlanSubscriptions();
  }
);

export const consumeTileQuota = createAction('subscriptions/consumeTileQuota');

export const setCurrentSubscriptions = createAction('subscriptions/setCurrent');
